import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import Navbar from "../components/navbar";
import { Footer } from "../components/Footer";
import HiringImages from "../components/HiringImages";
import CourseSlider from "../components/coursePageSlider";
import WhyChooseUs from "../components/whyChooseUs";
import HeroSection from "../components/coursePageHead";
import { useNavigate } from "react-router-dom";
import LottiePlayer from "../components/animationPlayer";
import HiringCarousel from "../components/HiringCarousel";
import TestimonialSection from "../components/TestimonialSection";
import FAQSection from "../components/FAQSection";
import FeedbackSection2 from "../components/FeedbackSection2";
import WorkshopPoster from "../components/WorkshopPoster";

const cards1 = [
  {
    url: "/poster/Course A 6-10.png",
    youtubeLink: "https://youtube.com/shorts/lqc7fhj3F2s?feature=share",
  },
  {
    url: "/poster/Course b(6th-10th).png",
    youtubeLink: "https://youtube.com/shorts/V3QmqEKyOb4?feature=share",
  },
];
const cards2 = [
  {
    url: "/poster/Course A(10th passed).png",
    youtubeLink: "https://youtube.com/shorts/lqc7fhj3F2s?feature=share",
  },
  {
    url: "/poster/Course b(11th-12th).png",
    youtubeLink: "https://youtube.com/shorts/V3QmqEKyOb4?feature=share",
  },
];
const cards3 = [
  {
    url: "/poster/Aptitude test.png",
    youtubeLink: "https://youtube.com/shorts/1SchqpTk3Zw?feature=share",
  },
  {
    url: "/poster/Aptitude test(undergrads and beyond).png",
    youtubeLink: "https://youtube.com/shorts/1SchqpTk3Zw?feature=share",
  },
];
// CourseCard component with image carousel
const CourseCard = ({ title, images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();
  const [showMessage, setShowMessage] = useState(false);

  const handleClick = () => {
    setShowMessage(true);

    // Optional: Hide the message after a few seconds
    setTimeout(() => {
      setShowMessage(false);
    }, 3000);
  };

  const goToNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPreviousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  const handleRegister = () => {
    navigate("/admission");
  };

  return (
    <div className="course-card">
      <p className="course-heading">{title}</p>
      <div style={{ position: "relative", width: "100%" }}>
        <div
          className="col-md-8"
          style={{ margin: "0 auto", position: "relative" }}
        >
          <img
            src={images[currentImageIndex]}
            style={{ width: "100%" }}
            alt={`Course ${currentImageIndex + 1}`}
          />

          <Box
            sx={{
              position: "absolute",
              bottom: "10px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "8px",
            }}
          >
            {images.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor:
                    currentImageIndex === index
                      ? "#30B0C7"
                      : "rgba(255, 255, 255, 0.8)",
                  transition: "background-color 0.3s",
                }}
              />
            ))}
          </Box>
        </div>
      </div>
      <button
        onClick={() => {
          handleClick();
        }}
        className="register-button"
      >
        REGISTER NOW!
      </button>
      {showMessage && (
        <Typography
          sx={{ color: "red", mt: 1, fontSize: "14px", textAlign: "center" }}
        >
          Registrations have not started yet!
        </Typography>
      )}
    </div>
  );
};

export const Courses = () => {
  const testimonials = [
    {
      name: "Navya",
      class: "8th",
      city: "Jalalpur, UP.",
      content:
        "YAPASSIO's Course A and Course B truly transformed my high school experience. Instead of just focusing on grades, I explored various skills and found a passion for Administration. The personalized career suggestions helped me choose a path that perfectly aligns with my interests and abilities. Thanks to YAPASSIO, I now feel confident and excited about my future in a field I love.",
      image: "student-1-pic.jpg",
    },
    {
      name: "Kartikeya",
      class: "8th",
      city: "Akbarpur, UP.",
      content:
        "Before joining YAPASSIO’s Course A and Course B, I was overwhelmed by the pressure to excel academically without knowing where my true talents lay. The course helped me uncover my knack for Engineering and provided practical tools to hone my skills. The guidance I received was invaluable, and now I’m pursuing course B to excel in Engineering skills that genuinely fit my strengths and interests.",
      image: "student-2-pic.jpg",
    },
    {
      name: "Rajveer Singh",
      class: "",
      city: "Akbarpur, Ambedkar Nagar, UP",
      content:
        "I joined Course A – Career Decision Year-long Workshop by YAPASSIO when I was in Class 10. That program not only gave me clarity about my strengths and career choices but also built my confidence to take bold decisions early in life. With the right mentorship and exposure from YAPASSIO, I chose Commerce in Class 11 and started exploring entrepreneurship. Today, in Class 12, I have successfully launched my own startup named Justgorcartt, a quick commerce platform designed for smaller towns. The continuous guidance, mentorship, and real-world learning I received from YAPASSIO played a huge role in shaping my journey from a student to a founder.",
      image: "student-3-pic.jpg",
    },
  ];

  const faqs = [
    {
      question: "1. What is YAPASSIO and what does it offer?",
      answer:
        "YAPASSIO is a startup dedicated to bridging the gap between academic achievement and skill development. We offer specialized courses for secondary education students that help them discover and enhance their skills, leading to informed career decisions. We also provide aptitude testing and career counseling for students at various educational levels, including high school graduates and university students.",
    },
    {
      question: "2. How do Course A and Course B help students?",
      answer:
        "Course A and Course B are designed to help secondary education students explore a range of skills and identify their strengths. Course A focuses on foundational skill discovery, while Course B aims to deepen expertise in the identified skills. Together, these courses equip students with insights and tools to make informed career choices aligned with their abilities and interests.",
    },
    {
      question:
        "3. Are the courses provided by YAPASSIO suitable for all students?",
      answer:
        "Yes, our courses are designed to accommodate a wide range of students. We tailor our approach to address individual needs, including those from low-income backgrounds. We provide personalized career suggestions and support to ensure that all students, regardless of their financial situation, can benefit from our services.",
    },
    {
      question:
        "4. How does YAPASSIO support students from low-income backgrounds?",
      answer:
        "YAPASSIO is committed to inclusivity. We offer personalized career suggestions and course options that consider both the student's skills and financial situation. Our goal is to ensure that financial constraints do not hinder students from exploring their potential and pursuing fulfilling career paths.",
    },
    {
      question:
        "5. What types of aptitude testing does YAPASSIO offer for high school graduates?",
      answer:
        "For students who have completed 11th and 12th grades, YAPASSIO provides stream-specific automatic aptitude testing across over 260 domains, as well as assessments for domains not tied to specific degree requirements. This helps students identify their strengths and interests in various fields.",
    },
    {
      question:
        "6. How can undergraduates and postgraduates benefit from YAPASSIO’s services?",
      answer:
        "Undergraduates and postgraduates can benefit from our graduation field-specific aptitude testing and assessments for degree-independent domains. We provide precise career counseling tailored to their academic and professional backgrounds, helping them make informed decisions about their career paths.",
    },
    {
      question: "7. How do I get started with YAPASSIO’s courses and services?",
      answer:
        "To get started, visit our website and fill out the registration form for the course or service that interests you. Once registered, you will receive detailed information on how to proceed, including course schedules, assessment procedures, and personalized guidance. If you have any questions, our support team is available to assist you.",
    },
  ];

  const secondaryEducationImages = ["/poster/Career Counselling.png"];

  const seniorSecondaryImages = ["/poster/Detailed career report card.png"];

  return (
    <div style={{ width: "100%" }}>
      <style>
        {`
          .hero-text {
            font-size: clamp(28px, 5vw, 60px);
            font-family: 'Aclonica';
            margin-bottom: 20px;
          }
          
          .section-heading {
            font-size: clamp(24px, 4vw, 50px);
            font-family: 'Aclonica';
            margin-bottom: 30px;
          }
          
          .course-heading {
            font-size: clamp(24px, 4vw, 50px);
            font-family: 'Roboto';
            font-weight: 500;
            text-align: center;
          }
          
          .course-card {
            width: 90%;
            box-shadow: 0px 2px 2px #ccc;
            display: flex;
            flex-direction: column;
            align-items: center;
            background: white;
            border-radius: 8px;
            margin-bottom: 50px;
            padding: 20px;
          }
          
          .register-button {
            border: none;
            padding: 15px 70px;
            font-size: clamp(16px, 2vw, 20px);
            border-radius: 35px;
            background: #30B0C7;
            color: white;
            margin: 20px 0;
            cursor: pointer;
            transition: background 0.3s ease;
          }
          
          .register-button:hover {
            background: #2795a8;
          }
          
          .testimonial-card {
            background: white;
            border-radius: 10px;
            padding: 20px;
            margin-bottom: 30px;
            display:flex;
            justify-content:center;
          }
          .testimonial-text{
            font-size:22px;
          }
          
          .faq-item {
            background-color: #f9f9f9;
            border-radius: 12px;
            margin: 16px 0;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            transition: transform 0.2s ease, box-shadow 0.2s ease;
            cursor: pointer;
          }

          .faq-item:hover {
            transform: translateY(-4px);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
          }

          
          .choose-us-text{
            font-size:20px;
          }
          .faq-answer {
            font-size: 16px;
            color: #555;
            line-height: 1.5;
          }
                    .faq-question {
            font-weight: 600;
            font-size: 20px;
            color: #333;
            margin-bottom: 8px;
            transition: color 0.2s ease;
          }

          .faq-item:hover .faq-question {
            color: #0077cc;
          }
          @media (max-width: 1100px) {
            .choose-us-text{
              font-size:14px;
            }
          }
          @media (max-width: 1024px) {
            .faq-question{
              font-size:20px;
            }
            .faq-answer{
              font-size:16px;
            }
            .testimonial-text{
              font-size:16px;
            }
          }
          @media (max-width: 768px) {
            .hero-text, .section-heading {
              text-align: center;
            }
          }
        `}
      </style>

      <Navbar />

      {/* Hero Section */}
      <HeroSection />
      {/* <div
        style={{
          minHeight: "85vh",
          height: "100%",
          alignItems: "center",
          display: "flex",
        }}
        className="cover-course"
      >
        <div
          className="row"
          style={{
            width: "100%",
            zIndex: "1",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            className="col-lg-8 col-md-12"
            style={{ padding: "8%", height: "100%" }}
          >
            <p className="hero-text">Still confused about your career?</p>
            <p className="hero-text">Let us help you out!!!</p>
            <p style={{ fontSize: "clamp(16px, 2vw, 22px)" }}>
              Here at YAPASSIO we guide you towards a passionate career aligned
              with your Skill, Knowledge, Behaviour, IQ, Decision Making,
              Emotional Intelligence and Aptitude
            </p>
          </div>
          <div
            className="col-lg-4 col-md-6 col-sm-6"
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              className="course-img"
              style={{
                position: "absolute",
                width: "80%",
                left: "20%",
                maxWidth: "400px",
              }}
              src="course-img1.png"
              alt="Course"
            />
            <img
              style={{ width: "80%", marginLeft: "10%", maxWidth: "400px" }}
              src="Polygon 1.png"
              alt="Polygon"
            />
          </div>
        </div>
      </div> */}
      {/* <WorkshopPoster /> */}

      {/* <HiringImages /> */}
      <HiringCarousel />

      {/* Courses Section */}
      <div
        className="intern-bg course-z"
        style={{ width: "100%", marginTop: "-50px", padding: "100px 20px" }}
      >
        <CourseSlider
          cards={cards1}
          title={"Secondary Education - Classes 6th to 10th"}
          nav={false}
          regnav={true}
        />
        <CourseSlider
          cards={cards2}
          title={"Senior Secondary Education: Classes 10th, 11th and 12th"}
          nav={false}
          regnav={true}
        />
        {/* <CourseSlider
          cards={cards3}
          title={"Automatic Aptitude Testing"}
          nav={true}
          regnav={false}
        /> */}
        {/* <FeedbackSection2 /> */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Secondary Education */}

          {/* Senior Secondary Education
          <CourseCard
            title="Detailed Career Path Report Card"
            images={seniorSecondaryImages}
          /> */}

          {/* Why Choose Us Section */}

          <WhyChooseUs />
          {/* <Box
            sx={{
              width: "80%",
              marginTop: "80px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <p className="section-heading">Why Choose Us?</p>
            <div
              className="row"
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-around",
                gap: "20px",
              }}
            >
              {[
                "Sustainable Approach",
                "Skillful Experts from Top IITs and NITs.",
                "Holistic Education for classes 6th to 10th",
                "Model based on highly researched career paths of successful personalities",
              ].map((item, ind) => (
                <div
                  key={ind}
                  style={{
                    width: "48%",
                    minWidth: "300px",
                    borderRadius: "40px",
                    background: "#97D7E2",
                    height: "80px",
                    padding: "0px",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      borderRadius: "50%",
                      background: "white",
                      aspectRatio: "1/1",
                      border: "2px solid #97D7E2",
                    }}
                  />
                  <div
                    className="choose-us-text"
                    style={{
                      width: "-webkit-fill-available",
                      display: "flex",

                      alignItems: "center",
                      fontFamily: "inter",
                      padding: "0px 10px",
                    }}
                  >
                    {item}
                  </div>
                </div>
              ))}
            </div>
          </Box> */}
          <TestimonialSection testimonials={testimonials} />
          {/* Testimonials */}
          {/* <Box sx={{ width: "80%", marginTop: "80px" }}>
            <p className="section-heading">Hear it from our Students</p>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="row">
                  <div className="col-sm-12 col-md-3">
                    <img
                      src={testimonial.image}
                      style={{ width: "100%" }}
                      alt="Student"
                    />
                  </div>
                  <div
                    className="col-sm-12 col-md-8"
                    style={{ padding: "20px" }}
                  >
                    <p
                      style={{
                        fontSize: "25px",
                        fontWeight: "500",
                        margin: "0px",
                      }}
                    >
                      {testimonial.name}
                    </p>
                    <span style={{ color: "#afafaf" }}>
                      Class-{testimonial.class}
                    </span>
                    <span style={{ marginLeft: "20px", color: "#afafaf" }}>
                      City -{testimonial.city}
                    </span>
                    <p className="testimonial-text">{testimonial.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </Box> */}

          {/* FAQs */}
          <FAQSection faqs={faqs} />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Courses;
